// Module
var code = "<kform kid=\"$ctrl.kid\" create=\"$ctrl.create\" name=\"formName\" options=\"$ctrl.options\" on-cancel=\"$ctrl.cancel()\" on-before-submit=\"$ctrl.checkDuplicates(forms, submissions, files)\" on-submit=\"$ctrl.submit(itemKid)\" submissions=\"$ctrl.submissions\"></kform> ";
// Exports
export default code;